import React, { useContext, useEffect, useState } from 'react';
import styles from './SocialMedia.module.scss';
import { SwiperSlide } from 'swiper/react';
import SwiperCustom from 'components/SwiperCustom/SwiperCustom';
import 'swiper/css';
import 'swiper/css/navigation';
import { Link } from 'react-router-dom';
import { DataContext } from '../../views/pages/Root';
import { addCustomPathToLink, generateKey } from '../../functions';

const SocialMedia = ({ api }) => {
  const data = useContext(DataContext);
  const [socialMedia, setSocialMedia] = useState(null);

  useEffect((_) => {
    setSocialMedia(data?.staticData?.find((prop) => prop.name == 'socials'));
  }, []);

  return (
    <section id={api?.id} className={styles.wrapper}>
      <div className={styles.sectionInspiration}>
        <div className={styles.topContext}>
          {!!api.attributes?.socialsTitle && <h2 className={styles.title}>{api.attributes.title}</h2>}
          {!!socialMedia?.data && (
            <div className={styles.socialContainer}>
              <div className={styles.socialWrapper}>
                {!!api.attributes?.socialsTitle && <p className={styles.socialTitle}>{api.attributes.socialsTitle}</p>}
                {socialMedia.data.map((social) => (
                  <a className={styles.socialIcon} href={social.link} target="_blank" key={generateKey()}>
                    <img src={addCustomPathToLink(social.icon.src, true)} alt={social.icon.alt} />
                  </a>
                ))}
              </div>
            </div>
          )}
        </div>
        {!!api.attributes?.images && (
          <SwiperCustom isSocialMedia className={`${styles.swiperInsp} ${styles.swiperCustomWithPrevButton}`} spaceBetween={10}>
            {api.attributes.images.map((image) => (
              <SwiperSlide className={styles.swiperSlide} key={generateKey()}>
                <figure className={styles.imageContainer}>
                  <img className={styles.image} src={addCustomPathToLink(image.src, true)} alt={image.alt} />
                </figure>
              </SwiperSlide>
            ))}
          </SwiperCustom>
        )}
      </div>
    </section>
  );
};

export default SocialMedia;
